import React from 'react';
import { formatDateString } from '../../components/FormattedDateTime/FormattedDateTime';
import DetailsViewer from '../../components/DetailsForm/DetailsViewer';
import { parsePeriodicity } from '../../utils';
import { useLabels } from '../../hooks/useLabels';

function BillInfo({ bill }) {
	const { t } = useLabels();
	if (!bill) {
		return null;
	}

	const verComprobante = () => {
		if (bill.comprobante?.fileLink) {
			window.open(bill.comprobante.fileLink, '_blank', 'noopener,noreferrer');
		}
	};

	const billFields = [
		{
			label: t('field.name'),
			key: 'name',
			type: 'text',
			value: bill.name || '',
			cols: 6,
		},
		{
			label: t('field.amount'),
			key: 'amount',
			type: 'number',
			value: bill.amount || '',
			cols: 3,
		},
		{
			label: bill.type === 'Periodico' ? t('field.startDate') : t('form.billDate'),
			key: 'startDate',
			type: 'text',
			value: formatDateString({
				dateValue: bill.startDate,
				dateFormat: 'DD/MM/YYYY',
			}),
			cols: 3,
		},
		{
			label: t('field.expirationDate'),
			key: 'expirationDate',
			type: 'text',
			value: formatDateString({
				dateValue: bill.expirationDate,
				dateFormat: 'DD/MM/YYYY',
			}),
			cols: 3,
		},
		{
			label: t('field.linkedAssetLower'),
			key: 'asset',
			type: 'text',
			value: bill.asset?.customId || bill.asset?.name || t('msg.noRelatedAsset'),
			link: bill.asset?._id ? `/AdminScreen/assets/asset/${bill.asset._id}` : null,
			cols: 6,
		},
		{
			label: t('field.type'),
			key: 'type',
			type: 'text',
			value: bill.type || '',
			cols: 3,
		},
		{
			label: t('field.periodicity'),
			key: 'periodicity',
			type: 'text',
			value: bill.type === 'Periodico' ? parsePeriodicity(bill.periodicity) : '',
			hide: bill.type !== 'Periodico',
			cols: 3,
		},
		{
			label: t('field.period'),
			key: 'period',
			type: 'text',
			value: bill.period ? formatDateString({
				dateValue: bill.period,
				dateFormat: bill.periodicity === 'Anual' ? 'YYYY' : 'MM/YYYY',
			}) : '',
			hide: bill.type !== 'Periodico',
			cols: 3,
		},
		{
			label: t('field.paidFull'),
			key: 'paid',
			type: 'text',
			value: (bill.paid || bill.confirmed) ? t('msg.yesPlain') : t('form.no'),
			cols: 3,
		},
		{
			label: t('form.comprobante'),
			key: 'comprobante',
			type: 'text',
			value: bill.comprobante?.fileLink ? (bill.comprobante.name || t('form.comprobante')) : t('msg.notAssignedFem'),
			button: bill.comprobante?.fileLink ? {
				label: t('action.viewReceipt'),
				onClick: verComprobante,
				hide: false,
			} : null,
			cols: 3,
		},
		{
			label: t('form.paymentAccount'),
			key: 'bankAccount',
			type: 'text',
			value: bill.bankAccount ? `${bill.bankAccount.bank} - ${bill.bankAccount.accountNumber} (${bill.bankAccount.currency})` : t('msg.notAssignedFem'),
			hide: !bill.bankAccount,
			cols: 6,
		},
		{
			label: t('field.folder'),
			key: 'folder',
			type: 'text',
			value: bill.folder || '',
			cols: 6,
		},
		{
			label: t('field.observations'),
			key: 'observations',
			type: 'text',
			value: bill.observations || '',
			cols: 12,
			rows: 10,
		},
	];

	return <DetailsViewer data={billFields} />;
}

export default BillInfo;
